export class ShiftRecordStatus {
  public static readonly None = null;
  public static readonly ReviewPrevious = 'ReviewPrevious';
  public static readonly ReviewPreviousActuals = 'ReviewPreviousActuals';
  public static readonly EnterCurrent = 'EnterCurrent';
  public static readonly EnterReasons = 'EnterReasons';
  public static readonly Done = 'Done';
  public static readonly EnterUOS = 'EnterUOS';
}